import { useCallback } from 'react';

import { buildAriBusinessUrl } from '../lib/ari-business-url';
import { useCurrentWorkspace } from './use-workspaces';

/**
 * Ari Business link builder bound to the workspace the app is currently scoped
 * to (the access token's `workspace` claim). Call sites that already hold a
 * workspace id should use `buildAriBusinessUrl` directly instead.
 */
export function useAriBusinessUrl(): (path?: string) => string {
  const { currentWorkspaceId } = useCurrentWorkspace();

  return useCallback((path?: string) => buildAriBusinessUrl(currentWorkspaceId, path), [currentWorkspaceId]);
}
